import React from "react";
import DropzoneS3Uploader from "react-dropzone-s3-uploader";
import { withRouter } from "react-router-dom";
import axios from "axios";
import "./S3Uploader.css";
import Spinner from "./Spinner";

const Configuration = require("./shared/configuration");

class UploadDisplay extends React.Component {
  renderText() {
    const { text } = this.props;
    return (
      <div>
        <span>{text}</span>
      </div>
    );
  }

  renderPreview() {
    const { realUploadedFile } = this.props;
    const { filename } = realUploadedFile;

    return (
      <div>
        <img src={`https://sales-visualizer-tool.happy-or-not.com/${filename}`} alt="logo" />
      </div>
    );
  }

  renderProgress() {
    const { progress } = this.props;
    return (
      <div className="progress">{`${progress} %`}</div>
    );
  }

  renderSpinner() {
    //<div className="spinner">SPINNER</div>
    return (
        <div className="spinner"><Spinner /></div>
    );
  }

  get renderMode() {
    let result;
    const { progress, realUploadedFile, text, isSpinner } = this.props;

    if (isSpinner) {
      result = 'Spinner';
    } else if (progress) {
      result = 'Progress';
    } else if (realUploadedFile) {
      result = 'Preview';
    } else if (text) {
      result = 'Text';
    }

    return result;
  }

  renderByMode() {
    return this[`render${this.renderMode}`]();
  }

  render() {
    return this.renderByMode();
  }
}

class S3Uploader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {isSpinner : false};
    this.handleFinishedUpload = this.handleFinishedUpload.bind(this);
  }

  setSpinner(value) {
    this.setState({isSpinner : value});
  }

  handleFinishedUpload(info) {
    const { history, conf } = this.props;
    this.setSpinner(true);
    axios
      .get("/api/colors/" + encodeURIComponent(info.filename))
      .then((response) => {
        this.setSpinner(false);
        const { data } = response;
        history.push(
          Configuration.configurationToUrl(
            Configuration.configurationWithChanges(conf, [
              { branding: { logo: encodeURIComponent(info.filename) } },
              { branding: { plateColor: data.plate } },
              { branding: { signColor: data.signColor } },
              { branding: { textColor: data.signText } },
              { branding: { suggestions: data.suggestions } }
            ])
          )
        );
      });
  }

  render() {
    const uploadOptions = {
      server: "/api",
      uploadRequestHeaders: {}
    };

    const s3Url = "https://sales-visualizer-tool.happy-or-not.com";
    const logo = this.props.match.params.logo; //logo param from URL

    const realUploadedFile = logo && {
      filename: decodeURIComponent(logo)
    };

    return (
      <DropzoneS3Uploader
        onFinish={this.handleFinishedUpload}
        s3Url={s3Url}
        maxSize={1024 * 1024 * 5}
        upload={uploadOptions}
        className="Dropzone"
      >
        <UploadDisplay
          text={this.props.text}
          realUploadedFile={realUploadedFile}
          isSpinner={this.state.isSpinner}
        />
      </DropzoneS3Uploader>
    );
  }
}

export default withRouter(S3Uploader);



// WEBPACK FOOTER //
// ./src/S3Uploader.js